import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  languageState: BehaviorSubject<string> = new BehaviorSubject("en");

  constructor( public translate: TranslateService) { }

  get currentLanguage() {
    return this.languageState.value;
}

set currentLanguage(value) {
  this.translate.use(value.toString())
  localStorage.setItem('currentLang', value);
    this.languageState.next(value);
}
}